import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const rsvptags = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 20,
      total: 0,
      page: 1,
    },
    selectedItems: [],
    loading: true,
  }),
  mutations: {
    setRSVPTags(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedRSVPTags(state, payload) {
      state.selectedItems = payload;
    },
    setRSVPTagPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getRSVPTags");
    },
    setRSVPTagTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getRSVPTags");
    },
  },
  actions: {
    async getRSVPTags(store) {
      store.state.loading = true;
      await axios
        .post("invitation/loadtags")
        .then((res) => {
          store.state.loading = false;
          return store.commit("setRSVPTags", res.data.data);
        });
    },
    async toggleRSVPTag(store, payload) {
      var res = await axios.post("RSVPTag/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteRSVPTag(store, payload) {
      await axios
        .post("invitation/deletetag", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setRSVPTagPage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
  },
  getters: {},
};
export default rsvptags;



// WEBPACK FOOTER //
// ./src/store/rsvptags.js